// Permisos de asignación de tareas (Victor 2026-06-03).
// Espejo de AgentPermissions::TASK_CREATOR_USER_IDS / TASK_ASSIGN_ALL_USER_IDS
// en el backend (lib/agent_permissions.rb). Mantener sincronizados.

// Quiénes pueden ASIGNAR/crear tareas (clic derecho en el cliente, "+ Nueva
// tarea", etc.): Victor Guzmán (3), Victor Manuel (7), Gabriela (41) + las
// encargadas de sucursal Rubi/Santiago (19), Karina/SDE (6), Kemely/Romana (4).
export const TASK_CREATOR_USER_IDS = [3, 7, 41, 19, 6, 4];

// De los que pueden asignar, quiénes ven a TODOS los agentes (todas las
// sucursales). El resto (encargadas) solo ve los agentes de SU sucursal
// principal — ver filtro en NewTaskModal.
export const TASK_ASSIGN_ALL_USER_IDS = [3, 7, 41];

export const canUserAssignTasks = userId =>
  TASK_CREATOR_USER_IDS.includes(userId);

export const userSeesAllAgentsForTasks = userId =>
  TASK_ASSIGN_ALL_USER_IDS.includes(userId);
